/* cl-cart.js — gaveta do carrinho (replica do UpCart do concorrente) sobre a Ajax API do Shopify.
   Abre por 'cl:cart:open' (cl-ui.js: icone do header, ATC, quick add), lista os itens de /cart.js
   (foto, opcoes, preco/riscado/economia, quantidade, remover, tags de desconto), contagem regressiva
   "reserved for", upsell (some o que ja esta no carrinho), descontos e total no botao de checkout.
   Kits (Kaching dele -> codigos nossos): clApplyKitCodes() poe no carrinho o codigo do maior tier que
   cada produto atinge (snippets/cl-kits-data.liquid). */
(function () {
  'use strict';
  var root = document.querySelector('[data-cl-cart-drawer]');
  if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var popup = $('#UpcartPopup'), panel = $('#CartPopup'), back = $('#UpcartPopupBackDrop');
  var icons = {};
  var tpl = root.parentNode.querySelector('template[data-cl-icons]') || document.querySelector('template[data-cl-icons]');
  if (tpl) Array.prototype.forEach.call(tpl.content.querySelectorAll('[data-i]'), function (s) { icons[s.getAttribute('data-i')] = s.innerHTML; });
  var KITS = {};
  try { KITS = JSON.parse((document.getElementById('cl-kits-data') || {}).textContent || '{}'); } catch (e) {}

  function fmt(c) {
    var f = window.clMoneyFormat || '${{amount}}', v = (c / 100).toFixed(2);
    return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(c / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function api(url, body) {
    return fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }
      : { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---- codigos dos kits ---- */
  function wantedCodes(cart) {
    var qty = {}, handles = {};
    cart.items.forEach(function (it) {
      if (it.properties && it.properties._cl_gift) return;
      qty[it.handle] = (qty[it.handle] || 0) + it.quantity; handles[it.handle] = 1;
    });
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.handle] = 1; });
    var codes = [];
    Object.keys(qty).forEach(function (h) {
      var tiers = (KITS[h] || []).filter(function (t) { return t.units <= qty[h] && (t.gifts || []).every(function (g) { return inCart[g]; }); });
      tiers.sort(function (a, b) { return b.units - a.units; });
      if (tiers[0]) codes.push(tiers[0].code);
    });
    return codes;
  }
  function currentCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable !== false || true; }).map(function (d) { return d.code; });
  }
  function isKitCode(c) {
    var all = {}; Object.keys(KITS).forEach(function (h) { KITS[h].forEach(function (t) { all[t.code.toUpperCase()] = 1; }); });
    return !!all[String(c).toUpperCase()];
  }
  function applyKitCodes(cart) {
    var p = cart ? Promise.resolve(cart) : api('/cart.js');
    return p.then(function (c) {
      var want = wantedCodes(c);
      var keep = currentCodes(c).filter(function (x) { return !isKitCode(x); });
      var next = keep.concat(want);
      var have = currentCodes(c);
      if (next.slice().sort().join(',') === have.slice().sort().join(',')) return c;
      return api('/cart/update.js', { discount: next.join(',') });
    });
  }
  window.clApplyKitCodes = function () { return applyKitCodes(); };

  /* ---- desenho ---- */
  function lineHTML(it) {
    var img = it.image ? it.image + (it.image.indexOf('?') > 0 ? '&' : '?') + 'height=176' : '';
    var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(', ');
    var unit = it.final_price, orig = it.original_price;
    var cmp = (it.compare_at_price && it.compare_at_price > orig) ? it.compare_at_price : (orig > unit ? orig : 0);
    var save = cmp ? (cmp - unit) * it.quantity : 0;
    var tags = (it.line_level_discount_allocations || []).map(function (d) {
      return '<span class="upcart-internal-component-tag upcart-public-component-tag"><span class="upcart-internal-component-tag__icon upcart-public-component-tag__icon">' + (icons.tag || '') + '</span><span class="upcart-internal-component-tag__text upcart-public-component-tag__text">' + esc(d.discount_application.title) + '</span></span>';
    }).join('');
    var gift = it.properties && it.properties._cl_gift;
    return '<li class="upcart-internal-cart-item upcart-public-cart-item" data-key="' + esc(it.key) + '"><div class="upcart-internal-component-product-tile upcart-public-component-product-tile"><div class="upcart-internal-component-product-tile__content upcart-public-component-product-tile__content">' +
      '<a href="' + esc(it.url) + '" class="upcart-internal-component-product-tile__image-wrapper upcart-public-component-product-tile__image-wrapper"><img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="88" height="88" class="upcart-internal-component-product-tile__image upcart-public-component-product-tile__image"></a>' +
      '<div class="upcart-internal-component-product-tile__info upcart-public-component-product-tile__info"><div class="upcart-internal-component-product-tile__header upcart-public-component-product-tile__header"><h4 class="upcart-internal-component-product-tile__product-title upcart-public-component-product-tile__product-title"><a href="' + esc(it.url) + '" class="upcart-internal-component-product-tile__title-link upcart-public-component-product-tile__title-link">' + esc(it.product_title) + '</a></h4>' +
      '<button type="button" class="upcart-internal-component-product-tile__remove-button upcart-public-component-product-tile__remove-button" aria-label="Remove ' + esc(it.product_title) + '" data-cl-remove>' + (icons.trash || '&times;') + '</button></div>' +
      (opts ? '<div class="upcart-internal-component-product-tile__variant upcart-public-component-product-tile__variant"><span class="upcart-internal-cart-items__key-value-pair">' + opts + '</span></div>' : '') +
      (gift ? '<div class="upcart-internal-component-product-tile__properties upcart-public-component-product-tile__properties">Free gift</div>' : '') +
      '<div class="upcart-internal-component-product-tile__product-pricing upcart-public-component-product-tile__product-pricing"><span class="upcart-internal-component-product-tile__price-group upcart-public-component-product-tile__price-group">' +
      (cmp ? '<span class="upcart-internal__visually-hidden">Original price</span><span class="upcart-internal-component-product-tile__price-compare-at upcart-public-component-product-tile__price-compare-at">' + fmt(cmp * it.quantity) + '</span>' : '') +
      '<span class="upcart-internal__visually-hidden">Sale price</span><span class="upcart-internal-component-product-tile__price upcart-public-component-product-tile__price">' + fmt(it.final_line_price) + '</span></span>' +
      (save > 0 ? '<span class="upcart-internal__visually-hidden">Savings</span><span class="upcart-internal-component-product-tile__savings upcart-public-component-product-tile__savings">(Save ' + fmt(save) + ')</span>' : '') + '</div>' +
      '<div class="upcart-internal-component-product-tile__controls upcart-public-component-product-tile__controls"><div class="upcart-internal-component-product-tile__quantity-selector upcart-public-component-product-tile__quantity-selector">' +
      '<button type="button" class="upcart-internal-component-product-tile__quantity-minus upcart-public-component-product-tile__quantity-minus" aria-label="Decrease quantity" data-cl-qty="-1">' + (icons.minus || '&minus;') + '</button>' +
      '<input type="text" inputmode="numeric" pattern="[0-9]*" aria-label="Product quantity" value="' + it.quantity + '" data-cl-qty-input>' +
      '<button type="button" class="upcart-internal-component-product-tile__quantity-plus upcart-public-component-product-tile__quantity-plus" aria-label="Increase quantity" data-cl-qty="1">' + (icons.plus || '+') + '</button></div>' +
      (tags ? '<div class="upcart-internal-component-product-tile__discount-codes upcart-public-component-product-tile__discount-codes">' + tags + '</div>' : '') +
      '</div></div></div></div></li>';
  }
  function render(cart) {
    $$('[data-cl-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
    document.querySelectorAll('.cart-count, [data-cart-count], cart-count, .header-actions__cart-icon .cart-bubble__text-count').forEach(function (e) { if (!root.contains(e)) e.textContent = cart.item_count; });
    var empty = !cart.items.length;
    $('[data-cl-cart-empty]').hidden = !empty;
    $$('[data-cl-filled]').forEach(function (e) { e.hidden = empty; });
    $('[data-cl-cart-items]').innerHTML = cart.items.map(lineHTML).join('');
    $$('[data-cl-cart-total]').forEach(function (e) { e.textContent = fmt(cart.total_price); });
    var inCart = {}; cart.items.forEach(function (it) { inCart[it.handle] = 1; });
    var anyUps = false;
    $$('[data-cl-ups]').forEach(function (u) { var hide = !!inCart[u.getAttribute('data-cl-ups')]; u.hidden = hide; if (!hide) anyUps = true; });
    var ups = $('[data-cl-upsell]'); if (ups) ups.hidden = !anyUps;
    var apps = (cart.cart_level_discount_applications || []).concat([]);
    var lineTitles = {}, total = 0;
    cart.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (d) { lineTitles[d.discount_application.title] = 1; total += d.amount; }); });
    apps.forEach(function (a) { lineTitles[a.title] = 1; total += a.total_allocated_amount; });
    var titles = Object.keys(lineTitles);
    var box = $('[data-cl-discounts]');
    box.hidden = !titles.length;
    $('[data-cl-discount-tags]').innerHTML = titles.map(function (t) {
      return '<span class="upcart-internal-component-tag upcart-public-component-tag"><span class="upcart-internal-component-tag__icon upcart-public-component-tag__icon">' + (icons.tag || '') + '</span><span class="upcart-internal-component-tag__text upcart-public-component-tag__text">' + esc(t) + '</span></span>';
    }).join('');
    $('[data-cl-discount-total]').textContent = '- ' + fmt(total);
  }
  var busy = false;
  function refresh() { return api('/cart.js').then(function (c) { return applyKitCodes(c); }).then(function (c) { return c && c.items ? c : api('/cart.js'); }).then(render); }
  window.clRefreshCart = refresh;

  /* ---- abrir/fechar ---- */
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    popup.classList.add('upcartPopupShow'); panel.classList.add('styles_active__'); back.classList.add('styles_active__');
    document.documentElement.classList.add('cl-cart-open');
    startTimer();
    refresh().then(function () { panel.focus({ preventScroll: true }); });
  }
  function close() {
    popup.classList.remove('upcartPopupShow'); panel.classList.remove('styles_active__'); back.classList.remove('styles_active__');
    document.documentElement.classList.remove('cl-cart-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('cl:cart:open', open);
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-cl-cart-close]')) { if (e.target.closest('a[href]') && !e.target.closest('#UpcartPopupBackDrop')) { close(); return; } e.preventDefault(); close(); return; }
    var li = e.target.closest('li[data-key]');
    var q = e.target.closest('[data-cl-qty]');
    if (q && li) {
      var inp = li.querySelector('[data-cl-qty-input]');
      change(li.getAttribute('data-key'), Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(q.getAttribute('data-cl-qty'), 10)));
      return;
    }
    if (e.target.closest('[data-cl-remove]') && li) { change(li.getAttribute('data-key'), 0); return; }
    var add = e.target.closest('[data-cl-ups-add]');
    if (add) {
      var tile = add.closest('[data-cl-ups]'), sel = tile && tile.querySelector('[data-cl-ups-select]');
      var id = sel ? sel.value : add.getAttribute('data-cl-ups-add');
      add.setAttribute('aria-busy', 'true');
      api('/cart/add.js', { items: [{ id: +id, quantity: 1 }] }).then(refresh).then(function () { add.removeAttribute('aria-busy'); });
    }
  });
  root.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-cl-qty-input]');
    if (inp) change(inp.closest('li[data-key]').getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && popup.classList.contains('upcartPopupShow')) close(); });
  function change(key, qty) {
    if (busy) return; busy = true;
    panel.setAttribute('aria-busy', 'true');
    api('/cart/change.js', { id: key, quantity: qty }).then(refresh).catch(function () {}).then(function () { busy = false; panel.removeAttribute('aria-busy'); });
  }

  /* ---- contagem regressiva "reserved for" (10:00 por visita, como o app) ---- */
  var timerOn = false;
  function startTimer() {
    if (timerOn) return; timerOn = true;
    var end = Date.now() + 10 * 60 * 1000;
    try { var s = +sessionStorage.getItem('cl-cart-reserve'); if (s > Date.now()) end = s; else sessionStorage.setItem('cl-cart-reserve', String(end)); } catch (e) {}
    function tick() {
      var left = Math.max(0, end - Date.now()), m = Math.floor(left / 60000), s = Math.floor(left / 1000) % 60;
      $$('[data-cl-timer]').forEach(function (e) { e.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s; });
      if (left > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  // estado inicial (contador do header, vazio/cheio) sem abrir
  api('/cart.js').then(render).catch(function () {});
})();
